"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SearchDisplayEventsPageDto = exports.DisplayEventPageOptionsDto = exports.DISPLAY_EVENT_SORT_ORDERS = exports.DISPLAY_EVENT_SORT_FIELDS = void 0;
const class_transformer_1 = require("class-transformer");
const class_validator_1 = require("class-validator");
const get_display_events_dto_1 = require("./get-display-events.dto");
exports.DISPLAY_EVENT_SORT_FIELDS = [
    "timestamp",
    "severity",
    "category",
    "type",
    "source",
];
exports.DISPLAY_EVENT_SORT_ORDERS = ["asc", "desc"];
class DisplayEventPageOptionsDto extends get_display_events_dto_1.DisplayEventSearchFiltersDto {
    onlyScreenshots;
    limit;
    offset;
    sortBy;
    sortOrder;
}
exports.DisplayEventPageOptionsDto = DisplayEventPageOptionsDto;
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_transformer_1.Transform)(({ value }) => value === true || value === "true"),
    (0, class_validator_1.IsBoolean)(),
    __metadata("design:type", Boolean)
], DisplayEventPageOptionsDto.prototype, "onlyScreenshots", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_transformer_1.Type)(() => Number),
    (0, class_validator_1.IsInt)(),
    (0, class_validator_1.Min)(1),
    (0, class_validator_1.Max)(500),
    __metadata("design:type", Number)
], DisplayEventPageOptionsDto.prototype, "limit", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_transformer_1.Type)(() => Number),
    (0, class_validator_1.IsInt)(),
    (0, class_validator_1.Min)(0),
    __metadata("design:type", Number)
], DisplayEventPageOptionsDto.prototype, "offset", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsIn)(exports.DISPLAY_EVENT_SORT_FIELDS),
    __metadata("design:type", String)
], DisplayEventPageOptionsDto.prototype, "sortBy", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsIn)(exports.DISPLAY_EVENT_SORT_ORDERS),
    __metadata("design:type", String)
], DisplayEventPageOptionsDto.prototype, "sortOrder", void 0);
class SearchDisplayEventsPageDto extends DisplayEventPageOptionsDto {
    displayIds;
}
exports.SearchDisplayEventsPageDto = SearchDisplayEventsPageDto;
__decorate([
    (0, class_validator_1.IsArray)(),
    (0, class_validator_1.IsString)({ each: true }),
    __metadata("design:type", Array)
], SearchDisplayEventsPageDto.prototype, "displayIds", void 0);
